/* src/app/_shared/components/datepicker/datepicker.component.scss */
:host {
  --height: 56px;
  --width: 100%;
  display: block;
  width: var(--width);
}
:host.ng-invalid .flow-datepicker .datepicker-container input {
  border-color: var(--ion-color-danger);
}
:host.ng-invalid .flow-datepicker .datepicker-container input:active,
:host.ng-invalid .flow-datepicker .datepicker-container input:focus,
:host.ng-invalid .flow-datepicker .datepicker-container input:hover {
  border-color: var(--ion-color-danger);
}
:host[ng-reflect-disabled] .datepicker-input input,
:host[disabled] .datepicker-input input,
:host[ng-reflect-disabled=true] .datepicker-input input {
  border-color: var(--ion-color-medium);
  color: var(--ion-color-medium);
}
:host[ng-reflect-disabled] .datepicker-input input + ion-icon,
:host[disabled] .datepicker-input input + ion-icon,
:host[ng-reflect-disabled=true] .datepicker-input input + ion-icon {
  color: var(--ion-color-medium);
}
.flow-datepicker {
  position: relative;
  height: var(--height);
  width: var(--width);
}
.flow-datepicker label {
  display: block;
  margin: var(--input-label-margin);
  font-size: var(--input-label-font-size);
}
.flow-datepicker .datepicker-input {
  position: absolute;
  width: 1em;
  height: 1em;
  opacity: 0;
}
.flow-datepicker .datepicker-container {
  position: relative;
  width: var(--width);
}
.flow-datepicker .datepicker-container ion-icon {
  display: inline-block;
  position: absolute;
  right: var(--input-icon-position-right);
  top: var(--input-icon-position-top);
  font-size: var(--icon-size);
  color: var(--ion-color-medium);
  transition: color 0.2s;
}
.flow-datepicker .datepicker-container .input-div {
  display: block;
  width: var(--width);
  min-height: 35px;
  padding: var(--input-padding-icon);
  border: 1px solid var(--ion-color-medium);
  border-radius: var(--radius);
  font-family: var(--font-family);
  font-size: var(--input-font-size);
  transition: border-color 0.2s;
}
.flow-datepicker .datepicker-container .input-div:not(:disabled):active,
.flow-datepicker .datepicker-container .input-div:not(:disabled):focus,
.flow-datepicker .datepicker-container .input-div:not(:disabled):hover {
  border-color: var(--ion-color-primary);
  outline: none;
}
.flow-datepicker .datepicker-container .input-div:not(:disabled):active:read-only,
.flow-datepicker .datepicker-container .input-div:not(:disabled):focus:read-only,
.flow-datepicker .datepicker-container .input-div:not(:disabled):hover:read-only {
  border-color: var(--ion-color-primary);
}
.flow-datepicker .datepicker-container .input-div:not(:disabled):active:read-only + ion-icon,
.flow-datepicker .datepicker-container .input-div:not(:disabled):focus:read-only + ion-icon,
.flow-datepicker .datepicker-container .input-div:not(:disabled):hover:read-only + ion-icon {
  color: var(--ion-color-primary);
}
.flow-datepicker .datepicker-container .input-div:not(:disabled):active + ion-icon,
.flow-datepicker .datepicker-container .input-div:not(:disabled):focus + ion-icon,
.flow-datepicker .datepicker-container .input-div:not(:disabled):hover + ion-icon {
  color: var(--ion-color-primary);
}
.flow-datepicker .datepicker-container .input-div::placeholder {
  color: var(--ion-color-medium);
}
/*# sourceMappingURL=datepicker.component-WSEPJFE3.css.map */
